export const floatRegex = /^((0|[1-9]\d*)(\.\d*)?)?$/;
export const bigRegex = /^((0|[1-9]\d*)(\.\d*)?(K|M|B|T)?)?$/;
export const convertBigNumber = (text) => {
    if (text.endsWith("K"))
        return Number.parseFloat(text.substring(0, text.length - 1)) * 1000;
    if (text.endsWith("M"))
        return Number.parseFloat(text.substring(0, text.length - 1)) * 1000000;
    if (text.endsWith("B"))
        return Number.parseFloat(text.substring(0, text.length - 1)) * 1000000000;
    if (text.endsWith("T"))
        return Number.parseFloat(text.substring(0, text.length - 1)) * 1000000000000;
    return Number.parseFloat(text);
};
export const unconvertBigNumber = (value) => {
    if (value < 1000) {
        return value.toString();
    }
    else if (value < 1000000) {
        return (value / 1000).toString() + "K";
    }
    else if (value < 1000000000) {
        return (value / 1000000).toString() + "M";
    }
    else if (value < 1000000000000) {
        return (value / 1000000000).toString() + "B";
    }
    return (value / 1000000000000).toString() + "T";
};
